// extracted by mini-css-extract-plugin
export default {"card":"UseCaseCard_card__YEunM","tag":"UseCaseCard_tag__HHORQ","title":"UseCaseCard_title__uDmzP","description":"UseCaseCard_description__r7TUJ"};